<template>
  <div style="min-height:70vh;padding:20px">
    <!-- <Form :model="searchData" inline @submit.native.prevent="getData(1)" :label-width="100">
      <FormItem label="名称">
        <Input v-model="searchData.name" clearable/>
      </FormItem>
      <Button type="primary" icon="ios-search" html-type="submit">搜索</Button>
    </Form> -->
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border style="margin:10px 0;">
      <template slot-scope="{ row }" slot="type">
        {{ row.type == 1 ? '微信' : row.type == 2 ? '支付宝' : '' }}
      </template>
      <template slot-scope="{ row }" slot="status">
        {{ row.status == 1 ? '未支付' : row.status == 2 ? '已支付' : '' }}
      </template>
    </Table>
    <Page style="text-align:right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  export default {
    data() {
      return {
        searchData: {
        },
        tableColumns: [
          { title: "ID", key: "id", width: 80, align: "center" },
          { title: "订单号", key: "order_sn", align: "center", minWidth: 120, },
          { title: "充值金额", key: "money", align: "center", minWidth: 120, },
          { title: "充值积分数量", key: "integral", align: "center", minWidth: 120, },
          { title: "充值时间", key: "create_time", align: "center", minWidth: 120, },
          { title: "充值方式", slot: "type", align: "center", minWidth: 120, },
          { title: "状态", slot: "status", align: "center", minWidth: 120, },
          // { title: "操作", slot: "action", align: "center"},
        ],
        indexUrl: "/app/recharge/index",
      };
    },
    mixins: [indexPage],
    methods: {
    }
  };
</script>
<style scoped>
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
</style>
